const ru = {
  //Header
  logoDescription: "Концептуальный кальянный клуб",

  //Menu
  home: "Главная",
  menu: "Меню",
  reservation: "Бронь",
  faq: "FAQ",

  //Profile
  firstNameLabel: "Имя",
  firstNamePlaceholder: "Ваше имя",
  nicknameLabel: "Никнейм",
  phoneLabel: "Номер телефона",
  phonePlaceholder: "+7 (___) ___-__-__",
  languageLabel: "Язык",
  save: "Сохранить",
  saving: "Сохранить",
  saved: "Сохранено",
  language: "Язык интерфейса",
  visitHistoryTitle: "История посещений",
  visitHistoryLoading: "Загрузка истории...",
  visitHistoryEmpty: "Пока нет посещений.",
  visitHistoryError: "Не удалось загрузить историю",
  visitTime: "Время",
  visitGuests: "Гостей",
  visitDuration: "Длительность",
  visitHoursShort: "ч.",
  visitMinutesShort: "мин.",

  //Home
  details: "Подробнее",
  comingSoon: "coming soon",

  reserveTitle: "Забронировать",
  reserveSubtitle: "сейчас",

  menuTitle: "Меню",

  residence: "Резиденция",
  parking: "Парковка",
  spaces: "Пространства",

  albumsTitle: "Фотоальбомы",
  albumsSubtitle: "и моменты",

  contactsTitle: "Контакты",
  contactsSubtitle: "и информация",

  writeTitle: "Написать",
  writeSubtitle: "директору",

  artifactsTitle: "Артефакты",
  cateringTitle: "Кейтеринг",
  merchTitle: "Мерч",

  altMenu: "Меню",

  hookahLunch: "Кальян-ланч",
  vinylRoom: "Винил-рум",
  radiolaRoom: "Радиола-рум",
  veranda: "Веранда",
  studio54: "STUDIO 54",

  //Reservation
  title: "Бронь",

  bookingNameLabel: "На какое имя бронь",
  bookingNameRequired: "Укажите имя",
  bookingNameInvalidError: "Укажите имя",
  bookingNameFormatError: "Только буквы",
  bookingNamePlaceholder: "Например: Иван",

  phoneLabelReservation: "Номер телефона",
  phoneRequired: "Укажите номер телефона",

  dateLabel: "Выберите дату",
  dateFormatError: "Формат ДД.ММ.ГГГГ",
  dateInvalidError: "Некорректная дата",
  dateClosedError: "Нерабочий день",

  guestsLabel: "Количество гостей",
  guestsRequired: "Укажите количество гостей",
  guestsPlaceholder: "Например: 3",
  guestsRangeError: "От 1 до 999 гостей",

  timeLabel: "Время посещения",
  timeRequired: "Укажите время посещения",
  timePlaceholderPrefix: "Например:",
  timeFormatError: "Формат ЧЧ:ММ",
  timeInvalidError: "Некорректное время",
  timeNotWorkingError: "Указано не рабочее время",

  durationLabel: "Длительность",
  durationRequired: "Укажите длительность",
  durationDefaultError: "От 1 до 24 часов",
  durationSecretError: "От 1 до 10 часов",
  durationStepError: "Шаг 30 минут",

  duration_1h: "1 час",
  duration_1_5h: "1.5 часа",
  duration_2h: "2 часа",
  duration_2_5h: "2.5 часа",
  duration_3h: "3 часа",
  duration_3_5h: "3.5 часа",
  duration_4plus: "4 и более",

  roomLabel: "Комната",
  roomPlaceholder: "Комната",

  commentLabel: "Дополнительный комментарий",
  commentPlaceholder: "Не обязательно",
  commentHint: "(P.S. на веранде бронь осуществляется исключительно день в день с 12:00)",

  submit: "Забронировать",
  submitting: "Бронирование...",
  success: "Заявка отправлена",
  submitError: "Не удалось отправить заявку. Попробуйте позже.",

  reservationHour: "часа",
  reservationHour2: "часов",

  // Parking
  parkingTitle: "Парковка",
  guestParkingHeadline:
    "Для Вашего удобства у Резиденции есть гостевая парковка",
  howItWorksP1:
    "Работает так: нужно забронировать любым удобным способом в Резиденции стол (заезд будет доступен в течение дня, на который сделана бронь). Если с Вами будут гости, кто тоже приедет на своих машинах, по запросу мы отправим Вам ссылку на регистрацию их автомобилей (Вашим компаньонам понадобится лишь оставить имя и телефон).",
  howItWorksP2:
    "Затем нужно подъехать к кафе «Дача Гашека» (Долгоруковская ул, 31стр32) и повернуть направо перед их зданием, там будет 2 шлагбаума (левый и правый). Нужен левый.",
  barrierPhoneLabel:
    "В момент, когда уже будете у этого шлагбаума, просто позвоните нам на специальный номер:",
  howItWorksP3: "Вуаля: парковать машину можно на любое свободное место.",
  howItWorksP4: "Выезд, соответственно, тоже по звонку.",
  parkingWalkDistance: "Резиденция находится в трех минутах ходьбы от парковки.",
  parkingNotesTitle: "Два важных уточнения:",
  parkingNote1:
    "1) Наша парковка доступна исключительно в том случае, если Вы держите путь именно в Резиденцию;",
  parkingNote2: "2) Парковка недоступна для каршеринга.",
  parkingThanks: "Спасибо за понимание! Ждем в гости!",
  buildRouteButton: "Построить маршрут до парковки",
  yandexAriaLabel:
    "Маршрут до Москва, Долгоруковская улица, 31с32 в Яндекс.Картах",
  yandexTitle: "Маршрут в Яндекс.Картах",
  parkingVideo: "Видео по въезду на парковку:",
  parkingVideoOld: "Тот же маршрут в вечернее время:",

  //SendSms
  infoText:
    "Оставьте сообщение/предложение/обратную связь. Директор свяжется с Вами в ближайшее время.",
  placeholder: "Ваше сообщение для директора",
  alreadySentError: "Уже отправлено. Подождите ответ директора.",
  sendFailError: "Не удалось отправить. Попробуйте ещё раз.",
  sentStatus: "Сообщение отправлено.",

  //Albums
  titleAlbums: "Фотоальбомы",
  titleAlbum: "Фотоальбом:",
  download: "Скачать",

  //Contacts
  ContactsTitle: "Контакты",
  mapTitle: "Yandex Map",

  workingHoursTitle: "Время работы:",
  workingHoursSunThu: "Вс-Чт 12:00-02:00",
  workingHoursFriSat: "Пт-Сб 12:00-04:00",
  workingHoursHolidayNote: "В праздничные дни график работы может быть изменен",

  addressTitle: "Адрес:",
  addressLine: "Москва, Долгоруковская улица, 25, стр. 1",
  entranceHint:
    "Вход прямо с Долгоруковской улицы: большая деревянная дверь и домофон",
  entrancePhotoLink: "(фото для наглядности)",

  residencePhonesTitle: "Телефоны Резиденции:",

  ParkingTitle: "Парковка",
  parkingHowToGetThere: "как проехать",
  parkingOpenBarrier: "Открыть шлагбаум:",

  wifiTitle: "Wi-Fi:",
  wifiNameLabel: "Имя:",
  wifiPasswordLabel: "Пароль:",

  socialNetworksTitle: "Социальные сети:",

  writeToDirector: "Написать директору",
  leaveReviewYandex: "Оставить отзыв в Yandex",

  entrancePhotoAlt: "Вход в резиденцию",

  //Residence
  navResidence: "Резиденция Мусье",
  navHistory: "История здания",
  navLegend: "Легенда о Мусье Лё Кальяне",
  navRules: "Правила",

  videoUnsupported: "Ваш браузер не поддерживает HTML5 видео.",

  residenceTitle: "Резиденция Мусье",
  residenceP1:
    "Концептуальный кальянный клуб в стиле баухаус с душой, историей и лоском.",
  residenceP2:
    "Мы искренние апологеты убранства в стиле второй половины ХХ века, а если точнее — Резиденция эстетически и по настроению — это славная эпоха 70х и 80х. Эклектичный винтажный стиль с подчеркнутыми элементами баухауса, обилием невероятно удобной и красивой мебели преимущественно скандинавского и центрально-европейского происхождения. «Собиралась», находилась и привозилась вся наша мебель, свет и декор аж 3,5 года, так как ратуем за подлинность изделий, не копий) Однако интерьер Резиденции (как и всех проектов Мусье) живой и пребывает в перманентной динамике: то есть периодически дополняется и обогащается различными диковинками.",
  residenceP3:
    "Кстати, практически вся техника, доступная взору, — аналоговая, более того: полностью рабочая и не бутафорская. В частности, у нас в коллекции есть классический «дискетный» macintosh, редчайшая магнитола со встроенным телевизором sharp 10P-35, мощная аудиосистема с виниловым проигрывателем Pioneer PL-780 в «Винил-руме», детально восстановленная радиола Rigonda в «Радиола-руме», несколько винтажных телевизоров Sanyo и Bang & Olufsen и так далее) А вот то, что «скрыто», то есть различные технические системы «в стенах», мы подобрали и интегрировали в соответствии со всем существующим ныне прогрессом и «умным» трендом в электронике. Чего стоит одна только система вентиляции! Там целый инженерный и крайне сложный проект, которым занималась лучшая в России команда по таким делам — аж 5 месяцев.",
  residenceP4:
    "Мы очень любим живые растения, поэтому в Резиденции их много, они получают весь необходимый уход, даже обустроили небольшую оранжерею. Подсвечники, классические настольные игры, подстилки и миски для четвероногих друзей, огнетушители и многое-многое другое искали и подбирали максимально внимательно, вообще каждую мелочь.",
  residenceP5:
    "Искренне гордимся тем, насколько здорово получилось сочетание особняка из первой половины XIX века с мебелированием в духе европейских домов второй половины XX. Фасадная стать одной эпохи в синергии с лоском другой.",

  historyTitle: "История здания",
  historyP1:
    "«Резиденция Мусье» располагается в полностью отреставрированном особняке, который был построен в далеком 1821 году и изначально являлся главным домом усадьбы статского советника Андрея Александровича Петрово-Соловово. Потом успел сменить несколько владельцев, в том числе принадлежал Марии Александровне Шиллер, с которой как раз (по легенде) и был знаком Мусье Лё Кальян. Они не раз встречались здесь за чашечкой чая и увлекательной беседой, Мусье рассказывал о своих странствиях, а еще нередко привозил гостинцы и различного рода артефакты в качестве дружеских презентов.",
  historyP2:
    "В период с 2019 по 2022 год наше здание претерпело давно назревшую глобальную реконструкцию (200 лет простояло все-таки). Оно сохранило свой исторический облик, но было значительно усилено и переработано по технической и конструктивной частям. А с учетом еще и наших многочисленных работ (в том числе восстановительных) — теперь пребывает в прекрасном состоянии. Мы бережно сохранили и отреставрировали лепнину, деревянные двери и окна, паркет в большой и малой гостиных, внедрили порядочное количество вспомогательных и умных систем — в общем, очень постарались с одной стороны сохранить его дух и стать, а с другой — сделать максимально технологичным, продуманным и комфортным: как для гостей, так и для работы.",
  historyP3:
    "Внутри царит абсолютно особенная атмосфера, во многом которая создается благодаря самой архитектуре помещений и залов: лепнина, высокие потолки, камины, паркет и деревянные окна с дверьми. Много света, воздуха и интеллигентного лейтмотива.",
  historyP4:
    "Есть гостиные, «заветные» комнаты, несколько небольших комнат-аттракционов, большая летняя веранда и так далее. Этажа у нас два, причем они отличаются друг от друга по настроению и духу.",
  historyP5:
    "Отдельная гордость заключается в обустройстве всех рабочих зон. Да, «открыта» взору лишь одна из них (рабочая зона кальянных мастеров), но заверяем, что и во всех остальных царят полный порядок и прекрасная эргономика.",
  historyP6:
    "В общем, получилось долго, бережно, основательно и сложно, но каков результат! Все для вас и для нас всех вместе, друзья!",

  legendTitle: "Легенда о Мусье Лё Кальяне",
  legendP1:
    "Доподлинно неизвестно, где и когда жил Мусье Лё Кальян. Некоторые полагают, что он был британцем и занимался поставками арабских товаров в Старый Свет. Другие настаивают на том, что Мусье Лё Кальян был тибетским монахом, практиковал курение кальяна во имя внутренней гармонии, много экспериментировал с разными способами забивки и прожил 150 лет. Кто-то утверждает, что он был французом, лично знакомым с Наполеоном. И, мол, иногда они даже покуривали кальян вместе, обсуждая планы на мир. Еще есть гипотеза о том, что Мусье Лё Кальян жил в России, собирался заводить моду на кальян среди дворянства, но помешала революция.",
  legendP2:
    "В любом случае, никаких научных трудов или исторических изысканий по поводу существования Мусье Лё Кальяна нет. Он не был великим полководцем, завоевателем или Генри Фордом. Зато он точно был настоящим фанатом кальяна, который ратовал за то, чтобы люди научились готовить его правильно, легко и смогли насладиться ярким ароматом и густым дымом. Мы высоко ценим такой порыв и будем стараться, чтобы его идеи продолжали жить.",

  rulesTitle: "Правила Резиденции",
  rulesIntro:
    "Для того, чтобы Ваш отдых проходил максимально качественно и дарил только положительные эмоции, у нас есть несколько правил:",
  rulesLi1: "У нас не принято использовать нецензурную лексику.",
  rulesLi2: "Резиденция открыта исключительно для совершеннолетних гостей.",
  rulesLi3: "Прийти к нам можно только в трезвом состоянии.",
  rulesLi4: "У нас не курят сигареты, айкос, электронные сигареты.",
  rulesLi5: "Не допускается пронос собственных напитков и алкоголя.",
  rulesLi6:
    "Резиденция — профессиональный и специализированный кальянный клуб. Заказ кальяна подразумевается по умолчанию.",
  rulesOutro: "Спасибо за понимание и желаем прекрасного отдыха!",

  altInterior: "Интерьер",
  altTechnique: "Техника",
  altPlantsDetails: "Растения и детали",
  altResidenceHistory: "История резиденции",
  altHistory: "История",

  //FAQ
  faqPage: {
    title: "FAQ",
    questions: [
      {
        id: 8,
        title: "Можно ли прийти к вам с собакой?",
        answer: `Мы очень любим собак и приветствуем их в Резиденции вместе с вами. Предлагаем миски с водичкой и специальные классные пледы-подстилки)

Однако главная наша задача — это чтобы всем вместе было максимально комфортно в Резиденции. То есть всем гостям без исключения. Поэтому касательно дог-френдли у нас существует несколько важных и простых правил:

1) Мы искренне любим все породы во всем многообразии их размеров, но, к сожалению, не сможем принять крупных собак, только маленьких или небольших (до 40 см в холке);

2) От маленьких собак в Резиденции ждём уважения к другим гостям и определенной воспитанности под стать своим замечательным владельцам. Иными словами, умение вести себя негромко и сидеть рядом с любимыми с хозяином или хозяйкой;

3) Как уже упоминали выше, у нас в наличии специальные пледы-подстилки, они водонепроницаемые. Однако грязные лапки - это все равно беда. Но мы постарались предусмотреть на всякий случай и это: в Резиденции всегда в наличии специальные салфетки для собак, они без спирта и гипоаллергенные;

4) Увы, специального туалета для собак в Резиденции нет, поэтому очень просим как следует погулять с собачкой перед визитом к нам)

Придерживаемся этих правил для всеобщего комфорта и надеемся на понимание) Со всей любовью к друзьям нашим меньшим и большим!`,
      },
      {
        id: 9,
        title: "Удобно ли у вас работать днём?",
        answer: `Да, более чем! Днём у нас комфортно работать за ноутбуком: стабильный интернет, спокойная атмосфера, удобные столики и наличие розеток у каждого из них.

Поскольку днём в будни многие гости часто приходят в Резиденцию именно поработать — мы даже предусмотрели удобные приставные столики для компьютеров, которые по первому запросу готовы вынести для Вас.

А еще по будням с 12:00 до 17:00 действует кальян-ланч (классические кальяны по 2400 р.)`,
      },
      {
        id: 10,
        title: "Можно ли прийти к вам со своими напитками или едой?",
        answer:
          "Приносить с собой напитки (в том числе алкоголь) в Резиденцию, к сожалению, нельзя. Еду приносить можно — или вы можете заказать её через любые сервисы доставки. Большая просьба: выбирайте, пожалуйста, блюда без резкого запаха, чтобы это не мешало гостям за соседними столиками. Спасибо за понимание!",
      },
      {
        id: 11,
        title: "Какие документы подходят для подтверждения 18+?",
        answer: `Документы, подтверждающие возраст:

- Паспорт гражданина РФ.
- Заграничный паспорт гражданина РФ.
- Временное удостоверение личности гражданина РФ.
- Паспорт моряка.
- Дипломатический паспорт гражданина РФ.
- Служебный паспорт гражданина РФ.
- Удостоверение личности военнослужащего или военный билет.
- Дипломатический, служебный или обычный заграничный паспорт иностранного гражданина.
- Вид на жительство лица без гражданства РФ.
- Разрешение на временное проживание лица без гражданства РФ.
- Удостоверение беженца.
- Свидетельство о предоставлении временного убежища на территории РФ.
- Водительское удостоверение.

Документы, не подтверждающие возраст:

- Любые документы в приложении Госуслуги (увы).
- Студенческий билет.
- Ксерокопии документов или их фотографии.`,
      },
      {
        id: 12,
        title: "Есть ли у вас PlayStation или Xbox?",
        answer: `Нет, у нас нет игровых консолей, но есть шикарный виниловый проигрыватель в «Винил-руме», радиола и современный проектор в «Радиола-руме», а еще и там, и там — винтажные телевизоры с отборным контентом времен XX века.

В малой гостиной есть маленькая комната-аттракцион с большим аркадным игровым автоматом, который доступен для всех гостей.`,
      },
      {
        id: 13,
        title: "Можно ли к вам прийти с несовершеннолетним гостем?",
        answer:
          "Нет, причем даже если такой несовершеннолетний гость будет в сопровождении родителей, братьев/сестер, любых законных опекунов. Резиденция доступна исключительно для гостей 18+.",
      },
      {
        id: 14,
        title: "Можно ли курить у вас электронные сигареты, айкос и т.п.?",
        answer:
          "Нет. Курение электронных сигарет, стиков и подобных устройств у нас запрещено, только кальян)",
      },
      {
        id: 15,
        title: "Можно ли отдохнуть у вас без заказа кальяна?",
        answer: `«Резиденция Мусье» — это специализированный кальянный клуб. Посещение такого типа заведений само по себе предполагает курение кальяна. Бывает, что часть гостей за столом курит кальян, часть — нет. В таком варианте это абсолютно нормально, тем более у нас установлена качественная и современная система вентиляции.

Без кальяна можно отдохнуть в любой из наших «заветных комнат»: «Радиола-рум» или «Винил-рум», однако, стоимость их аренды в таком случае составит 3000 р/час.`,
      },
      {
        id: 16,
        title:
          "Можно ли провести у вас фотосессию или профессиональную съёмку?",
        answer: ({ Link }) => (
          <>
            В Резиденции можно фотографировать и снимать видео. Главное — чтобы
            это не мешало другим гостям.
            {"\n\n"}
            Что касается профессиональных съёмок — всё зависит от формата. Если
            планируется фотосессия или профессиональная видеосъемка — можно{" "}
            <Link
              to="/send-sms"
              style={{
                color: "#366091",
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              написать директору
            </Link>{" "}
            в соответствующем разделе здесь в боте — он уточнит детали в
            зависимости от запроса.
          </>
        ),
      },
      {
        id: 17,
        title: "Можно ли у вас играть в покер?",
        answer:
          "Нет, здесь вынуждены ответить однозначно и категорично. Даже если без ставок — ни в каком виде нельзя.",
      },
    ],
  },

  //Rooms
  headerTitle: "Заветные комнаты и пространства",

  sacredRoomsTitle: "Заветные комнаты:",
  rentSpacesTitle: "Аренда пространств:",

  vinylRoomName: "Винил-рум",
  vinylRoomDesc:
    "Отдельная комната с виниловым проигрывателем, прекрасным звуком и большой коллекцией пластинок",

  radiolaRoomName: "Радиола-рум",
  radiolaRoomDesc:
    "Отдельная комната с радиолой и индивидуальным мини-кинотеатром",

  smallLivingRoomName: "Малая гостиная",
  smallLivingRoomDesc:
    "Вместительная, уютная и красивая — для компании до 15 человек",

  discoHallName: "Зал discopolaroid",
  discoHallDesc:
    "Большой зал в стиле 70х с отсылками к эпохе Studio 54 — для компании до 30 человек",

  bigLivingRoomName: "Большая гостиная",
  bigLivingRoomDesc:
    "Просторная, нарядная, с камином — для компании до 20 человек",

  wholeResidenceName: "Резиденция целиком",
  wholeResidenceDesc:
    "Оба этажа + веранда в теплое время. Эксклюзивное предложение, дорого",

  detailsButton: "Подробнее",

  faqSecretRoomsTitle: "FAQ по «заветным комнатам»:",
  faqRentSpacesTitle: "FAQ по аренде пространств:",

  faqPageRooms: {
    questions: [
      {
        id: 2,
        title:
          "Можно ли пользоваться техникой в «заветных комнатах» самостоятельно?",
        answer:
          "Конечно! Даже нужно) Наши ребята покажут, что и как там работает. Дополнительно к части устройств есть кастомные и наглядные инструкции.",
      },
      {
        id: 3,
        title: "Можно ли где-то посмотреть свой контент?",
        answer:
          "Да, в «Радиола-рум» можно посмотреть абсолютно любой контент на шикарном проекторе (фильмы, концерты, передачи, YouTube, презентации и так далее). Причем в самом высоком качестве и в сопровождении отличного звука 5.1.\n\nДополнительно в обеих «заветных комнатах» есть по винтажному телевизору — мы интегрировали в них возможность подключения к интернету, так что и на них можно точно так же посмотреть любой собственный или желаемый контент.\n\nНаши мастера все покажут, объяснят, как пользоваться.",
      },
      {
        id: 4,
        title: "Насколько громко можно слушать музыку в «заветных комнатах»?",
        answer: "Как душе будет угодно!)",
      },
      {
        id: 5,
        title: "Подходят ли «заветные комнаты» для деловых встреч?",
        answer:
          "Более чем. Как для деловых, так и для дружеских. В «Радиола-рум» можно в том числе использовать проектор для трансляции презентаций или же для осуществления видеозвонков. В любом случае — Вы будете в отдельных комнатах, что в том числе бывает нужно для конфиденциальных разговоров.\n\nА еще «заветные комнаты» прекрасно подходят для свиданий или же отдыха наедине с самим собой (иногда очень полезная и нужная штука).",
      },
      {
        id: 6,
        title:
          "Возможно ли при аренде одного из пространств принести свою еду и напитки, алкоголь?",
        answer:
          "Еду можно принести без проблем (например, заказать кейтеринг), а вот напитки и алкоголь возможны только наши, по меню. Их там очень много и на любой вкус.",
      },
      {
        id: 7,
        title:
          "При аренде какого из пространств можно будет включать свою музыку?",
        answer:
          'Это возможно при аренде зала «дискополароид» целиком (единственная просьба: что-то более-менее подходящее нашему концепту) и при аренде Резиденции целиком — в данном случае музыка возможна абсолютно любая.',
      },
      {
        id: 8,
        title: "Нужна ли предоплата при аренде пространств?",
        answer:
          'Зависит от пространства. При аренде Малой гостиной — предоплата не требуется, при аренде Большой гостиной или зала «дискополароид» — предоплата 20%, а при аренде Резиденции целиком — предоплата 50% в случае аренды на весь день и 30% не на весь день.',
      },
      {
        id: 9,
        title: "Возможно ли пригласить на мероприятие вашего фотографа?",
        answer:
          "Да, конечно. Мы свяжем Вас со Степаном, обговорите все детали и стоимость.",
      },
      {
        id: 10,
        title:
          'Возможен ли доступ на веранду при аренде зала «дискополароид» целиком?',
        answer:
          "К сожалению, нет, так как мы сдаем этот зал исключительно в то время, когда веранда не работает.",
      },
      {
        id: 11,
        title:
          "Возможно ли прийти к вам большой компанией, не арендуя при этом пространство?",
        answer:
          'Тут все зависит от того, насколько большая компания) У нас есть:\n- несколько больших столов с вместимостью 5-7 человек;\n- «заветные комнаты»: «Винил-рум»x на 5-7 человек и «Радиола-рум» на 4-6, стоимость аренды каждой составляет 1500 р./час, вне зависимости от времени и дня недели, депозит отсутствует;\n- объединение двух больших столов в зале «дискополароид» на 8-12 человек без аренды, но с депозитом:\n6000 р./час (пн-пт 12:00-19:00, пн-чт и вс 00:00–02:00, пт-сб 01:00-04:00, сб-вс 12:00-14:00)\nи\n9000 р./час (пн-чт 19:00-00:00, пт 19:00-01:00, сб 14:00-01:00, вс 14:00-00:00);\n- 2 варианта объединения столов на веранде: на 6-8 гостей без аренды и депозита + на 9-12 гостей без аренды, но с депозитом:\n7000 р./час (пн-пт 12:00-19:00, пн-чт и вс 00:00–02:00, пт-сб 01:00-04:00, сб-вс 12:00-14:00)\nи\n10000 р./час (пн-чт 19:00-00:00, пт 19:00-01:00, сб 14:00-01:00, вс 14:00-00:00).\n\nДля компаний от 8ми человек у нас предусмотрен сервисный сбор в размере 10%.',
      },
      {
        id: 12,
        title:
          "Можно ли как-то дополнительно украсить арендуемое пространство под стилистику мероприятия?",
        answer:
          'Да, это возможно. В «легкой» форме при аренде Малой гостиной и Большой гостиной, в более «продвинутом» варианте — при аренде зала «дискополароид» целиком, а серьезные, существенные изменения привычного убранства возможны только при аренде всей Резиденции целиком.',
      },
      {
        id: 13,
        title:
          "Возможно ли произвести оплату на расчетный счет как юр. лицо? Заключить договор на аренду?",
        answer: "Да, возможны оба варианта, как Вам будет удобнее.",
      },
    ],
  },

  //Rooms
  roomNames: {
    vinil: "Винил-рум",
    radiola: "Радиола-рум",
    livingrm: "Малая гостиная целиком",
    disco: "Зал discopolaroid целиком",
    bigliving: "Большая гостиная целиком",
    residence: "Резиденция целиком",
  },

  roomNames2: {
    vinil: "Винил-рум",
    radiola: "Радиола-рум",
    livingrm: "Малую гостиную целиком",
    disco: "Зал discopolaroid целиком",
    bigliving: "Большую гостиную целиком",
    residence: "Резиденцию целиком",
  },

  ariaPrevPhoto: "Предыдущее фото",
  ariaNextPhoto: "Следующее фото",

  pricePerHourLabel: "Цена в час",
  pricePerHourValue: "1500 рублей",

  wifiLabel: "Wi-Fi:",
  passwordLabel: "Пароль:",

  sendRequestPrefix: "Отправить заявку на:",

  bookingNameError: "Укажите имя",
  phoneError: "Укажите номер телефона",

  guestsOnlyDigitsError: "Только цифры",
  guestsError: "Укажите количество гостей",

  timeError: "Укажите время посещения",

  durationErrorText: "От 1 до 24 часов",
  durationError: "Укажите длительность",
  durationPlaceholder: "Укажите длительность (в часах)",

  descriptionRequiredError: "Укажите описание",
  descriptionLabel: "Дополнительный комнетрий",
  descriptionPlaceholder: "Укажите важные детали события",

  sending: "Отправка...",
  sent: "Заявка отправлена",
  send: "Отправить",

  bookPrefix: "Забронировать",

  vinil: [
    <>
      <b>«Винил-рум»</b> — это отдельная комната, где можно перенестись во
      времени и пространстве, окутав себя уединением, прекрасным звуком,
      аналоговостью, шорохами иглы по пластинке или визуальным шумом VHS-кассет.
      <br />
      <br />
      Здесь{" "}
      <b>
        винтажный виниловый проигрыватель Pioneer PL-780 в паре с прославленным
        японским усилителем Marantz SR4400
      </b>
      . Процесс воспроизведения пластинок полностью автоматический, даже с
      возможностью повтора! Звучит это все прекрасно. А еще в «Винил-руме»{" "}
      <b>полная и качественная шумоизоляция всех стен</b> - то есть с громкостью
      можно не стесняться)
      <br />
      <br />
      Если же настроение больше располагает к тактильному запуску кино,
      сериалов, телепередач или музыкальных клипов, здесь установлена датская
      классика 90х: <b>телевизор и видеомагнитофон Bang &amp; Olufsen</b>,
      которые в свое время были и остаются большой редкостью.
      <br />
      <br />
      Когда вы попадете в «Винил-рум» впервые, обязательно покажем и расскажем
      на практике, как все включить и как с этой техникой взаимодействовать.
      <br />
      <br />И для того, и для другого, в «Винил-руме» в вашем распоряжении{" "}
      <b>роскошная коллекция пластинок</b> (их там около 300: от классики до
      современной поп-сцены), а также{" "}
      <b>
        видеокассеты и приставка с лучшим визуальным контентом второй половины
        XX века
      </b>
      . Причем при желании на этом телевизоре воспроизвести можно все что
      угодно, он подключен к выделенной сети)
      <br />
      <br />
      <b>
        «Винил-рум» предполагает размещение 4-5 человек с комфортом, а 6-7
        человек уже в чуть стесненных условиях, но тоже вполне удобно.
      </b>
    </>,
  ],

  radiola: [
    <>
      Мы видим особый уют и удовольствие во взаимодействии с тактильной
      аналоговостью винтажной техники.
      <br />
      <br />
      <b>«Радиола-рум»</b> — это отдельная комната, которая дарит эти ощущения
      сразу в нескольких направлениях:
      <br />
      <br />
      <b>Что касается аналогового звука</b>, золотая пора радиол пришлась на
      середину прошлого века, когда крупногабаритные корпуса ламповых
      радиоприемников было легко совмещать с проигрывателями пластинок.
      <br />
      <br />
      Так вот, <b>бережно отреставрированная радиола Rigonda</b> – наш небольшой
      поклон тем временам и важный элемент этой «Заветной комнаты», подаривший
      ей ее название. Устройство полностью функционирует и может наполнять
      комнату звуком с небольших пластинок, коих мы подготовили компактную
      коллекцию. Ну, и радиола просто очень здорово выглядит сама по себе — как
      технический объект декора, задающий настроение комнате.
      <br />
      <br />
      <b>Источниками же визуального удовольствия здесь служат:</b>
      <br />
      <br />
      Во-первых, классический телевизор Sanyo — шикарно сохранившийся экземпляр
      от одного из трех "гигантов" японских производителей своего времени. Как и
      в случае с телевизором в «Винил-руме» и благодаря специальной приставке,
      мы постарались реализовать идею винтажного телевидения с рекламой,
      фильмами, передачами и клипами тех лет, смотрится все это очень
      занимательно. Однако при желании воспроизвести на этом телевизоре можно
      все, что угодно, он подключен к выделенной сети)
      <br />
      <br />
      Во-вторых, в «Радиола-рум» отлично вписался и современный образец техники:{" "}
      <b>ультракороткофокусный лазерный проектор</b>, на котором можно смотреть
      тоже вообще все — от фильмов и концертов, до сериалов, YouTube и рабочих
      презентаций. У него прекрасная картинка даже в солнечный день, а еще все
      качественно усилено отстроенным звуком 5.1. В общем, это{" "}
      <b>личный небольшой и функциональный кинотеатр</b>)
      <br />
      <br />
      Финальный штрих, создающий максимальный комфорт на все время пребывания,
      это невероятный{" "}
      <b>
        датский диван «stressless» из 80х с индивидуальной регулировкой угла
        наклона спинки
      </b>
      , причем у каждой секции она отдельная.
      <br />
      <br />
      Это ощущение уже сложно описать, лучше испытать на себе)
      <br />
      <br />
      <b>
        «Радиола-рум» предполагает размещение 4х человек с комфортом, а 5-6
        человек уже в чуть стесненных условиях, но будет тоже вполне удобно.
      </b>
    </>,
  ],

  livingrm: [
    <>
      <b>Малая гостиная</b> — это любимый многими гостями зал с камином,
      фортепиано и большими окнами, сквозь которые в светлое время проникают
      красивейшим образом лучи солнца.
      <br />
      <br />
      Стандартно в ней располагаются 2 столика, однако существует опция аренды
      Малой гостиной целиком: мы принесем дополнительную мебель, а еще можем
      организовать 2-3 высоких коктейльных стола для фуршета. На фото наглядно
      показали вариацию расстановки мебели.
      <br />
      <br />
      Мы <b>всегда готовы принять предзаказ</b> на любые позиции из нашего меню
      заранее, чтобы к Вашему приходу они уже были готовы и ожидали Вас в Малой
      гостиной.
      <br />
      <br />
      Можно принести свою еду (например, заказать кейтеринг или доставку), но
      нельзя приносить свой алкоголь и любые другие напитки.
      <br />
      <br />
      <b>
        Оптимальная вместимость Малой гостиной в случае аренды ее целиком — до
        15 человек.
      </b>
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>Стоимость складывается из суммы аренды и депозита:</b>
    </>,
    <>
      - Аренда в любой день недели и в любое время составляет 1500 р/час;
      <br />
      - Сумма депозита рассчитывается следующим образом:
      <br />
      <br />
      <i>Пн-чт в интервалах 12:00-19:00 и 00:00-02:00 — 7000 р/час;</i>
      <br />
      <i>Пн-чт в интервале 19:00-00:00 — 10000 р/час;</i>
      <br />
      <br />
      <i>Пт в интервале 12:00-19:00 — 7000 р/час;</i>
      <br />
      <i>Пт в интервале 19:00-01:00 — 15000 р/час;</i>
      <br />
      <i>Пт в интервале 01:00-04:00 — 9000 р/час;</i>
      <br />
      <br />
      <i>Сб в интервалах 12:00-18:00 и 01:00-04:00 — 9000 р/час;</i>
      <br />
      <i>Сб в интервале 18:00-01:00 — 15000 р/час;</i>
      <br />
      <br />
      <i>Вс в интервалах 12:00-18:00 и 00:00-02:00 — 8000 р/час;</i>
      <br />
      <i>Вс в интервале 18:00-00:00 — 12000 р/час.</i>
      <br />
      <br />
      От суммы депозита (и размера чека сверху депозита) предусмотрен сервисный
      сбор 10%.
      <br />
      <br />
      Предоплата не требуется.
    </>,
  ],

  disco: [
    <>
      <b>Зал «дискополароид»</b> — это большой зал в духе 70-80х с заметным
      реверансом в сторону эпохи Studio 54, то есть клубной жизни тех, своего
      рода, золотых времен.
      <br />
      <br />
      Здесь есть внушительный зеркальный диско-шар (у которого можно
      активировать кручение) и многочисленные элементы под стать. Диско Стю в
      зеркальной рамке особенно любим). Настроение залу задает в том числе и наш
      кастомный кальян «Studio 54», который давно стал сам по себе внутренней
      звездой Резиденции. А еще на полках, стеллажах, подоконниках собралась
      довольно уникальная коллекция «полароидов» в рабочем состоянии, которые мы
      тоже ценим за аналоговость и особую магию получающихся фотокарточек. Ну, и
      небольшая оранжерея (причем тоже с диско-мотивом!).
      <br />
      <br />
      Стандартно в «дискополароиде» располагаются 8 столиков, однако существует
      опция аренды его целиком: мы объединим столы, при необходимости принесем
      дополнительную мебель, организуем небольшой танцпол (если нужно), а еще
      можем предоставить хорошие концертные колонки с сабвуфером и диджейскую
      стойку (самого пульта нет). На фото наглядно показали вариацию расстановки
      мебели.
      <br />
      <br />
      Мы <b>всегда готовы принять предзаказ</b> на любые позиции из нашего меню
      заранее, чтобы к Вашему приходу они уже были готовы и ожидали Вас в зале «дискополароид».
      <br />
      <br />
      Можно принести свою еду (например, заказать кейтеринг или доставку), но
      нельзя приносить свой алкоголь и любые другие напитки.
      <br />
      <br />
      <b>
        Оптимальная вместимость зала «дискополароид» в случае аренды его целиком
        — до 30 человек.
      </b>
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>Стоимость складывается из суммы аренды и депозита:</b>
    </>,
    <>
      - Стоимость аренды рассчитывается следующим образом:
      <br />
      <br />
      <i>Пн-чт в интервалах 12:00-18:00 и 00:00-02:00 — 10000 р/час;</i>
      <br />
      <i>Пн-ср в интервале 18:00-00:00 — 15000 р/час;</i>
      <br />
      <i>Чт в интервале 18:00-00:00 — 20000 р/час;</i>
      <br />
      <br />
      <i>Пт в интервале 12:00-18:00 — 15000 р/час;</i>
      <br />
      <i>Пт в интервале 18:00-01:00 — 30000 р/час;</i>
      <br />
      <i>Пт в интервале 01:00-04:00 — 15000 р/час;</i>
      <br />
      <br />
      <i>Сб в интервалах 12:00-17:00 и 01:00-04:00 — 15000 р/час;</i>
      <br />
      <i>Сб в интервале 17:00-01:00 — 30000 р/час;</i>
      <br />
      <br />
      <i>Вс в интервале 12:00-17:00 — 15000 р/час;</i>
      <br />
      <i>Вс в интервале 17:00-00:00 — 20000 р/час;</i>
      <br />
      <i>Вс в интервале 00:00-02:00 — 10000 р/час.</i>
      <br />
      <br />
      - Сумма депозита рассчитывается следующим образом:
      <br />
      <br />
      <i>Пн-чт в интервале 12:00-18:00 — 10000 р/час;</i>
      <br />
      <i>Пн-чт в интервале 18:00-00:00 — 30000 р/час;</i>
      <br />
      <i>Пн-чт в интервале 00:00-02:00 — 20000 р/час;</i>
      <br />
      <br />
      <i>Пт в интервале 12:00-18:00 — 15000 р/час;</i>
      <br />
      <i>Пт в интервале 18:00-01:00 — 40000 р/час;</i>
      <br />
      <i>Пт в интервале 01:00-04:00 — 25000 р/час;</i>
      <br />
      <br />
      <i>Сб в интервале 12:00-17:00 — 25000 р/час;</i>
      <br />
      <i>Сб в интервале 17:00-01:00 — 40000 р/час;</i>
      <br />
      <i>Сб в интервале 01:00-04:00 — 25000 р/час;</i>
      <br />
      <br />
      <i>Вс в интервалах 12:00-17:00 и 00:00-02:00 — 25000 р/час;</i>
      <br />
      <i>Вс в интервале 17:00-00:00 — 40000 р/час.</i>
      <br />
      <br />
      От суммы депозита (и размера чека сверху депозита) предусмотрен сервисный
      сбор 10%.
      <br />
      <br />
      Предоплата — 20%.
      <br />
      <br />
      Бронирование лучше всего осуществлять не менее чем за день до желаемой
      даты.
      <br />
      <br />
      <b>
        Есть один важный момент, касающийся именно аренды «дискополароида»
        целиком:
      </b>{" "}
      такая опция доступна исключительно в период, когда наша веранда не
      работает (так как вход на нее осуществляется как раз через данный зал). То
      есть «дискополароид» сдается без возможности выхода на веранду.
    </>,
  ],

  bigliving: [
    <>
      <b>«Большая гостиная»</b> — это наш основной и главный, титульный зал.
      Восстановленная лепнина, деревянные окна, паркет, камин — все оформлено в
      лучших традициях баухауса, ощущение простора и особенное винтажное
      настроение.
      <br />
      <br />
      Стандартно в ней располагаются 5 столиков, однако существует опция аренды
      Большой гостиной целиком: мы принесем дополнительную мебель при
      необходимости, а еще можем организовать 2-3 высоких коктейльных стола для
      фуршета. На фото наглядно показали вариацию расстановки мебели.
      <br />
      <br />
      Мы <b>всегда готовы принять предзаказ</b> на любые позиции из нашего меню
      заранее, чтобы к Вашему приходу они уже были готовы и ожидали Вас в
      Большой гостиной.
      <br />
      <br />
      Можно принести свою еду (например, заказать кейтеринг или доставку), но
      нельзя приносить свой алкоголь и любые другие напитки.
      <br />
      <br />
      <b>
        Оптимальная вместимость Большой гостиной в случае аренды ее целиком — до
        20 человек.
      </b>
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>Стоимость складывается из суммы аренды и депозита:</b>
    </>,
    <>
      - Стоимость аренды рассчитывается следующим образом:
      <br />
      <br />
      <i>Пн-чт в интервалах 12:00-18:00 и 00:00-02:00 — 10000 р/час;</i>
      <br />
      <i>Пн-ср в интервале 18:00-00:00 — 15000 р/час;</i>
      <br />
      <i>Чт в интервале 18:00-00:00 — 20000 р/час;</i>
      <br />
      <br />
      <i>Пт в интервале 12:00-18:00 — 10000 р/час;</i>
      <br />
      <i>Пт в интервале 18:00-01:00 — 25000 р/час;</i>
      <br />
      <i>Пт в интервале 01:00-04:00 — 15000 р/час;</i>
      <br />
      <br />
      <i>Сб в интервалах 12:00-17:00 и 01:00-04:00 — 15000 р/час;</i>
      <br />
      <i>Сб в интервале 17:00-01:00 — 25000 р/час;</i>
      <br />
      <br />
      <i>Вс в интервале 12:00-17:00 — 15000 р/час;</i>
      <br />
      <i>Вс в интервале 17:00-00:00 — 20000 р/час;</i>
      <br />
      <i>Вс в интервале 00:00-02:00 — 10000 р/час.</i>
      <br />
      <br />
      - Сумма депозита рассчитывается следующим образом:
      <br />
      <br />
      <i>Пн-чт в интервале 12:00-18:00 — 10000 р/час;</i>
      <br />
      <i>Пн-чт в интервале 18:00-00:00 — 20000 р/час;</i>
      <br />
      <i>Пн-чт в интервале 00:00-02:00 — 15000 р/час;</i>
      <br />
      <br />
      <i>Пт в интервале 12:00-18:00 — 15000 р/час;</i>
      <br />
      <i>Пт в интервале 18:00-01:00 — 35000 р/час;</i>
      <br />
      <i>Пт в интервале 01:00-04:00 — 20000 р/час;</i>
      <br />
      <br />
      <i>Сб в интервале 12:00-17:00 — 15000 р/час;</i>
      <br />
      <i>Сб в интервале 17:00-01:00 — 40000 р/час;</i>
      <br />
      <i>Сб в интервале 01:00-04:00 — 20000 р/час;</i>
      <br />
      <br />
      <i>Вс в интервалах 12:00-17:00 и 00:00-02:00 — 15000 р/час;</i>
      <br />
      <i>Вс в интервале 17:00-00:00 — 30000 р/час.</i>
      <br />
      <br />
      От суммы депозита (и размера чека сверху депозита) предусмотрен сервисный
      сбор 10%.
      <br />
      <br />
      Предоплата — 20%.
      <br />
      <br />
      Бронирование лучше всего осуществлять не менее чем за день до желаемой
      даты.
    </>,
  ],

  Residence: [
    <>
      <b>Резиденция целиком</b> — это возможность погрузиться в атмосферу уюта,
      винтажного убранства и творчества без посторонних.
      <br />
      <br />В Вашем распоряжении будут оба этажа, все залы и «заветные комнаты»,
      веранда (в теплое время года) и полная свобода действий.{" "}
      <b>
        Возможно проведение корпоративов, свадеб, дней рождений, тематических
        мероприятий и вечеринок, презентаций.
      </b>
      <br />
      <br />
      Эксклюзивное предложение для тех, кто ценит приватность и хочет провести
      время по-особенному. Каждая аренда Резиденции целиком — обсуждается
      индивидуально: с учетом всех нюансов, предзаказа и прочих запросов гостей.
      Можно со своей едой (например, заказать кейтеринг), но нельзя приносить
      свой алкоголь и любые другие напитки.
      <br />
      <br />
      Дополнительно мы можем помочь с приглашением диджеев и артистов, арендой
      техники (музыка, свет и так далее), возможны услуги талантливого
      декоратора, фотографа и видеографа, при необходимости — дадим контакты
      проверенных кейтерингов по еде. А еще у нас есть дополнительная мебель и
      фуршетные столы.
      <br />
      <br />
      <b>
        Вместимость всей Резиденции в случае аренды её целиком — до 100 человек.
        Если с верандой – до 150 человек.
      </b>{" "}
      Важный нюанс: веранда доступна исключительно в теплое время года и может
      работать только до 23:00.
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>
        Стоимость складывается из суммы аренды и депозита (зависит от
        конкретного времени и дня недели), рассчитывается индивидуально.
      </b>
      <br />
      <br />
      От суммы депозита (и размера чека сверху депозита) предусмотрен сервисный
      сбор 10%.
      <br />
      <br />
      При аренде Резиденции целиком на весь день — предусмотрена скидка 10%.
      <br />
      <br />
      Предоплата в случае аренды на весь день — 50%, не на весь день — 30%.
      <br />
      <br />
      Бронирование возможно не менее, чем за неделю до желаемой даты.
    </>,
  ],
};

export default ru;
